<header class="tw-flex tw-flex-col tw-w-full tw-mb-4 tw-mx-1 tw-min-w-0 tw-gap-1">
    <div class="tw-flex tw-justify-between tw-items-center tw-w-full tw-gap-3">
        <div class="tw-flex tw-items-center tw-min-w-0 tw-flex-1">
            @if (isMobile) {
                <button mat-icon-button (click)="back.emit()" class="tw-mr-2">
                    <mat-icon>arrow_back</mat-icon>
                </button>
            }
            <div class="tw-text-xl tw-font-medium tw-tracking-tight tw-text-[var(--sys-text)] tw-min-w-0 tw-w-full">
                <ng-content select="[mainTitle]"></ng-content>
            </div>
        </div>
        <div class="tw-flex tw-gap-3 tw-flex-none">
            <ng-content select="[mainActions]"></ng-content>
        </div>
    </div>
    <div class="tw-w-full">
        <ng-content select="[mainHeaderExtra]"></ng-content>
    </div>
</header>

<div class="tw-flex-1 tw-w-full tw-overflow-y-auto tw-overflow-x-hidden tw-box-border tw-pb-1">
    <div class="tw-w-full"
        [class.tw-h-full]="fullHeight"
        [class.tw-grid]="useGrid"
        [class.tw-gap-4]="useGrid"
        [class.tw-items-stretch]="useGrid"
        [ngClass]="(useGrid) ? (isMobile ? 'tw-grid-cols-1' : 'lg:tw-grid-cols-2') : ''"
    >
        <ng-content select="[mainBody]"></ng-content>
    </div>
</div>